import { PlanningsDeliveryWithLegRunEntity } from 'src/entities/PlanningsDelivery.entity';

/**
 * 2 車両の配送計画を入れ替えてよいかを判定する。断る理由があれば文字列、無ければ null。
 *
 * 条件も文言も V3Plans/Component.tsx:1137-1147 に合わせる。同じ操作で画面ごとに
 * 通ったり通らなかったりすると、どちらが正しいのか利用者に判断できない。
 */
export function resolveSwapBlockReason(
  deliveryIds: readonly [number, number],
  deliveries: readonly PlanningsDeliveryWithLegRunEntity[],
): string | null {
  const targets = deliveryIds.map((id) => deliveries.find((d) => d.id === id));
  if (targets.some((d) => d == null)) return '配送計画を特定できませんでした';

  // operations が奇数 = 宵積み（積みだけで降ろしが翌日に回る）。V3Plans と同じ判定
  if (targets.some((d) => d.operations.length % 2 !== 0)) {
    return '宵積みが存在しているため、配送計画の入れ替えはできません';
  }
  if (targets.some((d) => d.operations.some((op) => op.fixed))) {
    return '確定した計画のため、配送計画の入れ替えはできません';
  }
  return null;
}
